// App.js
import React, { useState } from 'react';
import './App.css';
import './global.css';
import Navbar from './components/navbar';
import SearchBar from './components/SearchBar';
import Details from './components/Details';
import Home from './components/Home';
import Footer from './components/Footer';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import DocCategory from './components/DocCategory';
import DocArticle from './components/DocArticle';
import Contact from './components/Contact';
import SearchResults from './components/SearchResults';
import { AuthProvider } from './context/AuthContext';
import { ApiLoadingProvider } from './context/ApiLoadingContext';
import AdminLayout from './components/admin/AdminLayout';
import AdminLogin from './components/admin/AdminLogin';
import AdminForgotPassword from './components/admin/AdminForgotPassword';
import AdminResetPassword from './components/admin/AdminResetPassword';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminCategories from './components/admin/AdminCategories';
import AdminArticles from './components/admin/AdminArticles';
import AdminArticleVersions from './components/admin/AdminArticleVersions';
import AdminQuickLinks from './components/admin/AdminQuickLinks';
import AdminApplications from './components/admin/AdminApplications';
import CustomerSupportChatbot from './components/CustomerSupportChatbot';

function AppContent() {
  const location = useLocation();
  const isAdminArea = location.pathname.startsWith('/admin');
  const [isSidebarOpen, setIsSidebarOpen] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia('(min-width: 1024px)').matches
  );
  const handleToggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  return (
    <div className="App">
      {!isAdminArea && (
        <>
          <Navbar isSidebarOpen={isSidebarOpen} onToggleSidebar={handleToggleSidebar} />
          <SearchBar />
          <Details />
        </>
      )}
      <Routes>
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="login" element={<AdminLogin />} />
          <Route path="forgot-password" element={<AdminForgotPassword />} />
          <Route path="reset-password" element={<AdminResetPassword />} />
          <Route path="categories" element={<AdminCategories />} />
          <Route path="applications" element={<AdminApplications />} />
          <Route path="articles" element={<AdminArticles />} />
          <Route path="articles/:nid/versions" element={<AdminArticleVersions />} />
          <Route path="quick-links" element={<AdminQuickLinks />} />
        </Route>
        <Route path="/" element={<Home />} />
        <Route path=":category" element={<DocCategory />} />
        <Route path=":category/kb/:id" element={<DocArticle />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      {!isAdminArea && <Footer />}
      {!isAdminArea && <CustomerSupportChatbot />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <ApiLoadingProvider>
        <Router>
          <AppContent />
        </Router>
      </ApiLoadingProvider>
    </AuthProvider>
  );
}

export default App;
